import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_SLRParsers = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SLR Parsers"
    videos={[
      "https://www.youtube.com/embed/sWBSQoKNDUo",
      "https://www.youtube.com/embed/d2HBvYAOSwU",
    ]}
    takeaways={[]}
    questions={[
      `1) Consider the following grammar: Construct the SLR parsing table and also parse the input "a*b+a"

E -> E + T | T
T -> T F | F
F -> F * | a | b`,

      `2) The grammar given below is used to parse all possible expressions in C that involve (only) variables of pointer datatype (ignoring the semi-colon). Check whether the above grammar is SLR(1). If yes, then parse the following: ptr1 = ptr2

program -> expression | assignment
assignment -> expression = expression
expression -> identifier | *expression
(Assume that identifier is a terminal symbol)`,

      `3) Consider the following grammar. Construct the SLR parsing table and parse the input "a*b+a". Provide a step-by-step explanation of the parsing process.

S -> S * T | S + T | T
T -> (S) | a | b`,

      `4) Check whether the given context-free grammar is SLR or not. Justify your answer with suitable reasons.

S -> L = R
S -> R
L -> *R
L -> id
R -> L`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_SLRParsers;
